import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    currentStep: String
  }

  connect() {
    this.scrollToStep(this.currentStepValue);
  }

  scrollToStep(stepId) {
    const stepEl = document.getElementById(stepId);
    if (!stepEl) return;

    stepEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.dispatch('scrolled', { detail: { step: stepId } });
  }
}
